module.exports = __webpack_public_path__ + "img/aficheA4-CursoFormacion.d18bbad2.jpg";